
import { calculateCapacity, formatCapacity, supportsCapacity } from '../../utils/capacityCalculations'

/**
 * CapacityInfo Component
 * Phase 5 Task 3: Display battery capacity information below SOC gauges
 * 
 * Shows remaining and total capacity in Ah/Wh format for battery devices
 */
function CapacityInfo({ 
  device, 
  soc, 
  realTimeData, 
  className = '', 
}) {
  // Only show capacity info for battery devices
  if (!supportsCapacity(device)) {
    return null
  }

  // Calculate capacity information
  const capacity = calculateCapacity(soc, realTimeData, device)
  const formatted = formatCapacity(capacity)

  // Don't render if no capacity data available
  if (!formatted.hasData) {
    return (
      <div className={`capacity-info text-center text-muted ${className}`}>
        <small>
          <i className="bi bi-info-circle me-1"></i>
          Capacity data unavailable
        </small>
      </div>
    )
  }

  return (
    <div className={`capacity-info text-center ${className}`}>
      <div className="mb-1">
        <small className="text-success">
          <i className="bi bi-battery-charging me-1"></i>
          <strong>Remaining:</strong> {formatted.remaining}
        </small>
      </div>
      <div>
        <small className="text-muted">
          <i className="bi bi-battery-full me-1"></i>
          <strong>Total:</strong> {formatted.total}
        </small>
      </div>
    </div>
  )
}

export default CapacityInfo
